<header class="platform-header">
  <div class="header-left">
    @if (!isSidebarPinned()) {
      <p-button
        icon="pi pi-bars"
        [text]="true"
        [rounded]="true"
        severity="secondary"
        styleClass="hamburger-button"
        (onClick)="menuToggle.emit()"
      ></p-button>
    }
    <div class="logo-section" (click)="onLogoClick()">
      <div class="logo-container">
        <img src="assets/Alphastar_Logo.webp" alt="AlphaStar Logo" class="platform-logo" />
      </div>
    </div>

    <div class="location-switcher">
      <p-button
        (onClick)="locationOp.toggle($event)"
        [text]="true"
        severity="secondary"
        styleClass="location-button"
      >
        <div class="location-display">
          <img src="assets/location-black.svg" alt="location" class="tab-icon" />
          <span class="location-label">{{ selectedLocation()?.name || 'Select Location' }}</span>
          <img src="assets/arrow-down-black.svg" alt="location" class="tab-icon" />
        </div>
      </p-button>
      <p-popover #locationOp position="bottom">
        <div class="location-menu-content">
          @if (locationLoading()) {
            <div class="loading-state">loading...</div>
          } @else if (locations().length === 0) {
            <div class="empty-state">
              <span>No locations available</span>
            </div>
          } @else {
            @for (loc of locations(); track loc.id; let last = $last) {
              <div
                class="platform-menu-item"
                [class.active]="loc.active"
                (click)="selectLocation(loc); locationOp.hide()"
              >
                <div class="p-menuitem-content">
                  <a class="p-menuitem-link">
                    <img
                      src="assets/location-black-icon.svg"
                      [alt]="loc.name"
                      class="platform-icon-xs"
                    />
                    <span class="p-menuitem-text">{{ loc.name }}</span>
                    @if (loc.active) {
                      <i
                        class="pi pi-check"
                        style="margin-left: auto; color: var(--primary-500)"
                      ></i>
                    }
                  </a>
                </div>
              </div>
              @if (!last) {
                <p-divider styleClass="m-0" />
              }
            }
          }
        </div>
      </p-popover>
    </div>
  </div>

  <div class="header-right">
    <div class="user-profile">
      <img [src]="config()?.theme?.clockIcon" alt="Profile" class="header-icon" />
      <div class="user-info">
        <span class="user-name"
          >{{ currentTime() | date: 'dd-MMM-yy HH:mm' }} ({{ localTimeZone() }})</span
        >
        <span class="user-role">{{ currentTime() | date: 'dd-MMM-yy HH:mm' : 'UTC' }} (UTC)</span>
      </div>
    </div>
    <div class="user-profile-devider"></div>

    <div class="user-profile">
      <img [src]="config()?.theme?.profileIcon" alt="Profile" class="header-icon" />
      <div class="user-info">
        <span class="user-name">{{ userDetails()?.fullName || '--' }}</span>
        <span class="user-role">{{ userDetails()?.designation }}</span>
      </div>
    </div>

    @if (availablePlatforms().length > 1) {
      <div class="platform-switcher">
        <p-button
          (onClick)="op.toggle($event)"
          [outlined]="true"
          severity="secondary"
          styleClass="switcher-button"
        >
          <div class="current-platform-display">
            <img [src]="config()?.icon" [alt]="config()?.name" class="platform-icon-xs" />
            <span class="switcher-label">{{ config()?.name }}</span>
            <i class="pi pi-angle-down"></i>
          </div>
        </p-button>
        <p-popover #op position="bottom">
          <div class="platform-menu-content">
            @for (item of platformMenuItems; track item.label; let last = $last) {
              <div
                class="platform-menu-item"
                (click)="item.command?.({ originalEvent: $event }); op.hide()"
              >
                <div class="p-menuitem-content">
                  <a class="p-menuitem-link">
                    <img [src]="item.icon" [alt]="item.label" class="platform-icon-xs" />
                    <span class="p-menuitem-text">{{ item.title }}</span>
                  </a>
                </div>
              </div>
              @if (!last) {
                <p-divider styleClass="m-0" />
              }
            }
          </div>
        </p-popover>
      </div>
    }
  </div>
</header>
